(() => {
  const pz = document.querySelector('[data-m43-pz]');
  const form = document.getElementById('ModelProductForm');
  if (!pz || !form) return;
  const root = form.closest('[data-model-product]') || document;

  // Move the personalizer into the buy box and hand variant selection to the wagon radios.
  const hiddenId = form.querySelector('[data-model-variant-id]');
  if (hiddenId) hiddenId.removeAttribute('name');
  form.insertBefore(pz, form.firstElementChild);
  form.setAttribute('enctype', 'multipart/form-data');

  const wagons = [...pz.querySelectorAll('[data-wagon]')];
  const cars = [...pz.querySelectorAll('[data-car]')];
  const photoInputs = [...pz.querySelectorAll('[data-photo-input]')];
  const compare = root.querySelector('.model-product__compare');
  const saving = root.querySelector('.m43-saving');
  const dialog = pz.querySelector('[data-chibi-dialog]');
  const maxBytes = Number(pz.dataset.maxPhotoMb || 10) * 1048576;
  const chibiEndpoint = pz.dataset.chibiEndpoint;
  const chibiJobs = new Map();
  // Chibis already made from the current photo, per wagon and character, so switching back is instant and free.
  const chibiCache = new Map();
  const photoHint = 'JPG, PNG or WEBP · max 10 MB';
  const readyMessage = 'Your chibi preview is ready. The name plaque stays the same.';

  const carFor = (wagon) => cars.find((node) => node.dataset.car === wagon.dataset.wagon);
  const wagonFor = (car) => wagons.find((node) => node.dataset.wagon === car.dataset.car);

  const setCount = (radio) => {
    const count = Number(radio.dataset.wagons);
    wagons.forEach((wagon) => {
      const on = Number(wagon.dataset.wagon) <= count;
      wagon.hidden = !on;
      wagon.disabled = !on;
    });
    cars.forEach((car) => { car.hidden = Number(car.dataset.car) > count; });
    const available = radio.dataset.available === 'true';
    root.querySelectorAll('[data-model-price], [data-model-sticky-price]').forEach((node) => { node.textContent = radio.dataset.price; });
    if (compare) {
      compare.textContent = radio.dataset.compare || '';
      compare.style.display = radio.dataset.compare ? '' : 'none';
    }
    if (saving) {
      saving.textContent = radio.dataset.saving || '';
      saving.style.display = radio.dataset.saving ? '' : 'none';
    }
    root.querySelectorAll('[data-model-submit], [data-model-sticky-submit], [data-model-buy-now]').forEach((button) => {
      button.disabled = !available;
      if (button.matches('[data-model-submit], [data-model-sticky-submit]')) {
        button.textContent = available ? 'Add to cart' : 'Sold out';
      }
    });
    const label = root.querySelector('[data-model-availability-label]');
    if (label) label.textContent = available ? 'Available to order' : 'Currently unavailable';
    if (hiddenId) {
      hiddenId.value = radio.value;
      hiddenId.dataset.available = radio.dataset.available;
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', radio.value);
    window.history.replaceState({}, '', url);
  };

  const syncCar = (wagon) => {
    const car = carFor(wagon);
    if (!car) return;
    const name = wagon.querySelector('[data-name-input]').value.trim();
    car.querySelector('[data-car-name]').textContent = name || 'Name';
    const chibiUrl = wagon.querySelector('[data-chibi-url]')?.value;
    const picked = wagon.querySelector('input[type="radio"]:checked');
    car.classList.toggle('has-chibi', Boolean(chibiUrl));
    if (chibiUrl) car.querySelector('[data-car-img]').src = chibiUrl;
    else if (picked) car.querySelector('[data-car-img]').src = picked.dataset.charSrc;
  };

  const openZoom = (wagon) => {
    const chibiUrl = wagon.querySelector('[data-chibi-url]')?.value;
    if (!dialog || !chibiUrl) return;
    const character = wagon.querySelector('input[type="radio"]:checked')?.value || '';
    const name = wagon.querySelector('[data-name-input]').value.trim();
    dialog.querySelector('[data-chibi-dialog-title]').textContent = `Wagon ${wagon.dataset.wagon} · ${character}`;
    dialog.querySelector('[data-chibi-dialog-img]').src = chibiUrl;
    dialog.querySelector('[data-chibi-dialog-img]').alt = `Chibi ${character.toLowerCase()} for wagon ${wagon.dataset.wagon}`;
    dialog.querySelector('[data-chibi-dialog-name]').textContent = name || 'Name';
    dialog.showModal();
  };

  // Downscale to a 1024px JPEG so uploads stay small and HEIC from Safari is converted.
  const toJpeg = async (file) => {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, 1024 / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    return new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.9));
  };

  const setChibiState = (wagon, state, message) => {
    const box = wagon.querySelector('[data-chibi]');
    box.hidden = state === 'off';
    box.dataset.state = state;
    box.querySelector('[data-chibi-status]').textContent = message || '';
    carFor(wagon)?.classList.toggle('is-loading', state === 'loading');
  };

  const showChibi = (wagon, url) => {
    wagon.querySelector('[data-chibi-url]').value = url;
    wagon.querySelector('[data-chibi-img]').src = url;
    setChibiState(wagon, 'done', readyMessage);
    syncCar(wagon);
  };

  const cancelJob = (wagon) => {
    chibiJobs.get(wagon)?.abort();
    chibiJobs.delete(wagon);
  };

  // Photo removed or replaced: forget every chibi made from the old photo.
  const clearChibi = (wagon) => {
    cancelJob(wagon);
    chibiCache.delete(wagon);
    const urlInput = wagon.querySelector('[data-chibi-url]');
    if (urlInput) urlInput.value = '';
    if (wagon.querySelector('[data-chibi]')) setChibiState(wagon, 'off');
    syncCar(wagon);
  };

  const makeChibi = async (wagon) => {
    const file = wagon.querySelector('[data-photo-input]').files[0];
    const character = wagon.querySelector('input[type="radio"]:checked')?.value;
    cancelJob(wagon);
    if (!chibiEndpoint || !file || !character) return;

    const cached = chibiCache.get(wagon)?.get(character);
    if (cached) {
      showChibi(wagon, cached);
      return;
    }

    const job = new AbortController();
    chibiJobs.set(wagon, job);
    wagon.querySelector('[data-chibi-url]').value = '';
    syncCar(wagon);
    const saved = chibiCache.get(wagon)?.size
      ? ' Your earlier chibis are saved — switch back any time.'
      : '';
    setChibiState(wagon, 'loading', `Creating your chibi ${character.toLowerCase()}… this takes about 15 seconds.${saved}`);
    try {
      const photo = await toJpeg(file);
      const body = new FormData();
      body.append('photo', photo, 'photo.jpg');
      body.append('character', character);
      const response = await fetch(chibiEndpoint, { method: 'POST', body, signal: job.signal });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.url) throw new Error(data.error || 'Preview unavailable. Please try again.');
      if (!chibiCache.has(wagon)) chibiCache.set(wagon, new Map());
      chibiCache.get(wagon).set(character, data.url);
      showChibi(wagon, data.url);
    } catch (error) {
      if (job.signal.aborted) return;
      const message = error instanceof TypeError || error.name === 'InvalidStateError'
        ? 'We could not read this photo. Please try a JPG or PNG.'
        : error.message;
      setChibiState(wagon, 'error', message);
    } finally {
      if (chibiJobs.get(wagon) === job) chibiJobs.delete(wagon);
      if (!job.signal.aborted) syncCar(wagon);
    }
  };

  const checkPhoto = (input) => {
    const status = input.parentElement.querySelector('[data-photo-status]');
    const file = input.files[0];
    const upload = input.closest('.m43-pz__upload');
    upload.classList.remove('is-error', 'is-done');
    if (!file) {
      status.textContent = photoHint;
      return false;
    }
    if (file.size > maxBytes) {
      input.value = '';
      status.textContent = 'This photo is larger than 10 MB. Please choose a smaller file.';
      upload.classList.add('is-error');
      return false;
    }
    status.textContent = file.name;
    upload.classList.add('is-done');
    return true;
  };

  pz.addEventListener('change', (event) => {
    const target = event.target;
    const wagon = target.closest('[data-wagon]');
    if (target.matches('[data-m43-pz-count]')) setCount(target);
    else if (target.matches('[data-photo-input]')) {
      if (chibiEndpoint) clearChibi(wagon);
      if (checkPhoto(target)) makeChibi(wagon);
    } else if (wagon) {
      if (target.type === 'radio' && wagon.querySelector('[data-photo-input]').files.length) makeChibi(wagon);
      else syncCar(wagon);
    }
  });
  pz.addEventListener('input', (event) => {
    if (event.target.matches('[data-name-input]')) syncCar(event.target.closest('[data-wagon]'));
  });
  pz.addEventListener('click', (event) => {
    const zoom = event.target.closest('[data-chibi-zoom]');
    const car = event.target.closest('[data-car].has-chibi');
    if (zoom) openZoom(zoom.closest('[data-wagon]'));
    else if (car) openZoom(wagonFor(car));
  });
  dialog?.addEventListener('click', (event) => {
    // Close on the × button or a click on the backdrop (outside the dialog box).
    if (event.target.closest('[data-chibi-close]') || event.target === dialog) dialog.close();
  });

  form.addEventListener('submit', (event) => {
    const busy = [...chibiJobs.keys()].find((wagon) => !wagon.disabled);
    if (busy) {
      event.preventDefault();
      busy.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setChibiState(busy, 'loading', 'Almost there — please wait for your chibi preview before adding to cart.');
      return;
    }
    // Skip empty photo/chibi fields so orders don't carry blank properties.
    photoInputs.forEach((input) => { if (!input.files.length) input.disabled = true; });
    pz.querySelectorAll('[data-chibi-url]').forEach((input) => { if (!input.value) input.disabled = true; });
  });
  window.addEventListener('pageshow', () => {
    photoInputs.forEach((input) => { input.disabled = false; });
    pz.querySelectorAll('[data-chibi-url]').forEach((input) => { input.disabled = false; });
  });

  const checked = pz.querySelector('[data-m43-pz-count]:checked');
  if (checked) setCount(checked);
  wagons.forEach(syncCar);
})();
